import { render, staticRenderFns } from "./OffersPage.vue?vue&type=template&id=73219e26&scoped=true"
import script from "./OffersPage.vue?vue&type=script&lang=js"
export * from "./OffersPage.vue?vue&type=script&lang=js"
import style0 from "./OffersPage.vue?vue&type=style&index=0&id=73219e26&prod&scoped=true&lang=css"
import style1 from "./OffersPage.vue?vue&type=style&index=1&id=73219e26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73219e26",
  null
  
)

export default component.exports